var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 44,
    viewBox: "0 0 149 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 147.5,
    height: 43,
    rx: 4.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.4496 23.9262C72.8624 23.9262 70.7537 25.8941 70.7537 28.6045C70.7537 31.2984 72.8624 33.2828 75.4496 33.2828C78.0379 33.2828 80.1466 31.2984 80.1466 28.6045C80.1455 25.8941 78.0368 23.9262 75.4496 23.9262ZM75.4496 31.4414C74.0317 31.4414 72.8096 30.2721 72.8096 28.6056C72.8096 26.9215 74.0328 25.7698 75.4496 25.7698C76.8675 25.7698 78.0896 26.9215 78.0896 28.6056C78.0896 30.271 76.8675 31.4414 75.4496 31.4414ZM65.2042 23.9262C62.617 23.9262 60.5083 25.8941 60.5083 28.6045C60.5083 31.2984 62.617 33.2828 65.2042 33.2828C67.7925 33.2828 69.9012 31.2984 69.9012 28.6045C69.9012 25.8941 67.7925 23.9262 65.2042 23.9262ZM65.2042 31.4414C63.7863 31.4414 62.5642 30.2721 62.5642 28.6056C62.5642 26.9215 63.7874 25.7698 65.2042 25.7698C66.6221 25.7698 67.8442 26.9215 67.8442 28.6056C67.8453 30.271 66.6221 31.4414 65.2042 31.4414ZM53.0184 25.3628V27.3472H57.7682C57.6263 28.4637 57.2545 29.2788 56.6869 29.8453C55.9961 30.5361 54.9148 31.2984 53.0184 31.2984C50.0946 31.2984 47.8088 28.9411 47.8088 26.0173C47.8088 23.0935 50.0946 20.7362 53.0184 20.7362C54.5958 20.7362 55.7475 21.3566 56.5978 22.1541L57.9981 20.7538C56.8101 19.6197 55.2338 18.7518 53.0184 18.7518C49.0133 18.7518 45.6462 22.0122 45.6462 26.0173C45.6462 30.0224 49.0133 33.2828 53.0184 33.2828C55.1799 33.2828 56.8112 32.5733 58.0861 31.2445C59.3973 29.9333 59.8054 28.0897 59.8054 26.6014C59.8054 26.1416 59.7702 25.7159 59.6987 25.3617H53.0184V25.3628ZM102.857 26.9039C102.468 25.8589 101.28 23.9262 98.8521 23.9262C96.442 23.9262 94.4389 25.8226 94.4389 28.6045C94.4389 31.2269 96.4244 33.2828 99.082 33.2828C101.226 33.2828 102.467 31.9716 102.981 31.2093L101.386 30.1456C100.855 30.9255 100.128 31.4392 99.082 31.4392C98.037 31.4392 97.2923 30.9607 96.8138 30.0213L103.069 27.4341L102.857 26.9039ZM96.4772 28.4637C96.4244 26.6553 97.8775 25.7346 98.9236 25.7346C99.7387 25.7346 100.429 26.1427 100.66 26.7268L96.4772 28.4637ZM91.3919 33.0001H93.4467V19.249H91.3919V33.0001ZM88.0237 24.9723H87.9533C87.4924 24.4223 86.6058 23.9262 85.4904 23.9262C83.1507 23.9262 81.0068 25.9821 81.0068 28.6232C81.0068 31.2456 83.1507 33.2839 85.4904 33.2839C86.6069 33.2839 87.4924 32.7878 87.9533 32.2213H88.0237V32.8945C88.0237 34.6842 87.0667 35.6412 85.5256 35.6412C84.2672 35.6412 83.4873 34.7381 83.1683 33.9758L81.3786 34.7205C81.8923 35.9602 83.2563 37.4848 85.5256 37.4848C87.9357 37.4848 89.974 36.0669 89.974 32.6107V24.2111H88.0248V24.9723H88.0237ZM85.6675 31.4414C84.2496 31.4414 83.0627 30.2534 83.0627 28.6232C83.0627 26.9743 84.2496 25.7698 85.6675 25.7698C87.0667 25.7698 88.1656 26.9743 88.1656 28.6232C88.1656 30.2534 87.0667 31.4414 85.6675 31.4414ZM112.487 19.249H107.568V33.0001H109.62V27.7905H112.485C114.76 27.7905 116.998 26.1438 116.998 23.5203C116.998 20.8968 114.761 19.249 112.487 19.249ZM112.539 25.8765H109.62V21.163H112.539C114.074 21.163 114.945 22.4335 114.945 23.5203C114.945 24.5851 114.074 25.8765 112.539 25.8765ZM125.225 23.902C123.738 23.902 122.2 24.5565 121.563 26.0074L123.384 26.7675C123.774 26.0074 124.5 25.7588 125.26 25.7588C126.321 25.7588 127.4 26.3957 127.418 27.5276V27.6695C127.046 27.4572 126.25 27.1393 125.277 27.1393C123.314 27.1393 121.314 28.2184 121.314 30.2347C121.314 32.075 122.924 33.2597 124.728 33.2597C126.108 33.2597 126.869 32.6404 127.346 31.9144H127.417V32.9759H129.399V27.7036C129.4 25.2638 127.576 23.902 125.225 23.902ZM124.976 31.4381C124.305 31.4381 123.367 31.1015 123.367 30.2699C123.367 29.2084 124.535 28.8014 125.544 28.8014C126.444 28.8014 126.87 28.9961 127.418 29.2612C127.258 30.5361 126.162 31.4381 124.976 31.4381ZM136.617 24.2023L134.264 30.1643H134.194L131.752 24.2023H129.541L133.203 32.5348L131.115 37.1702H133.256L138.9 24.2023H136.617ZM118.131 33.0001H120.182V19.249H118.131V33.0001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6598 11.2672C52.6598 12.189 52.387 12.9227 51.8403 13.4705C51.2199 14.1217 50.4103 14.4473 49.4159 14.4473C48.4633 14.4473 47.6526 14.1173 46.9871 13.4573C46.3205 12.7962 45.9872 11.9778 45.9872 11.001C45.9872 10.0231 46.3205 9.20473 46.9871 8.54473C47.6526 7.88363 48.4633 7.55363 49.4159 7.55363C49.8889 7.55363 50.341 7.64603 50.77 7.82973C51.2001 8.01453 51.5444 8.25983 51.8018 8.56673L51.2221 9.14753C50.7854 8.62503 50.1837 8.36433 49.4148 8.36433C48.7196 8.36433 48.119 8.60853 47.6119 9.09693C47.1048 9.58533 46.8518 10.22 46.8518 10.9999C46.8518 11.7798 47.1048 12.4145 47.6119 12.9029C48.119 13.3913 48.7196 13.6355 49.4148 13.6355C50.1518 13.6355 50.7667 13.3902 51.2584 12.8985C51.5774 12.5784 51.7622 12.1329 51.8117 11.562H49.4148V10.7689H52.6125C52.6455 10.9416 52.6598 11.1077 52.6598 11.2672Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7309 8.51069H54.7257V10.6029H57.4361V11.396H54.7257V13.4882H57.7309V14.3H53.8776V7.69999H57.7309V8.51069Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3069 14.3H60.4588V8.51069H58.6152V7.69999H63.1505V8.51069H61.3069V14.3Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4318 14.3V7.69999H67.2799V14.3H66.4318Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.041 14.3H70.1929V8.51069H68.3493V7.69999H72.8846V8.51069H71.041V14.3Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4698 13.4475C80.8208 14.1141 80.0145 14.4474 79.0498 14.4474C78.0851 14.4474 77.2788 14.1141 76.6309 13.4475C75.9819 12.7809 75.6585 11.9647 75.6585 11C75.6585 10.0353 75.9819 9.21908 76.6309 8.55248C77.2788 7.88588 78.0851 7.55148 79.0498 7.55148C80.009 7.55148 80.8142 7.88698 81.4654 8.55688C82.1166 9.22678 82.4422 10.0408 82.4422 11C82.4422 11.9647 82.1177 12.7809 81.4698 13.4475ZM77.2568 12.8942C77.7452 13.3892 78.3425 13.6356 79.0498 13.6356C79.7571 13.6356 80.3555 13.3881 80.8428 12.8942C81.3312 12.3992 81.5765 11.7678 81.5765 11C81.5765 10.2322 81.3312 9.60078 80.8428 9.10578C80.3555 8.61078 79.7571 8.36438 79.0498 8.36438C78.3425 8.36438 77.7452 8.61188 77.2568 9.10578C76.7695 9.60078 76.5242 10.2322 76.5242 11C76.5242 11.7678 76.7695 12.3992 77.2568 12.8942Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6324 14.3V7.69999H84.6642L87.8718 12.8337H87.9081L87.8718 11.5621V7.69999H88.7199V14.3H87.8344L84.4783 8.91659H84.442L84.4783 10.1882V14.3H83.6324Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6598 11.2672C52.6598 12.189 52.387 12.9227 51.8403 13.4705C51.2199 14.1217 50.4103 14.4473 49.4159 14.4473C48.4633 14.4473 47.6526 14.1173 46.9871 13.4573C46.3205 12.7962 45.9872 11.9778 45.9872 11.001C45.9872 10.0231 46.3205 9.20473 46.9871 8.54473C47.6526 7.88363 48.4633 7.55363 49.4159 7.55363C49.8889 7.55363 50.341 7.64603 50.77 7.82973C51.2001 8.01453 51.5444 8.25983 51.8018 8.56673L51.2221 9.14753C50.7854 8.62503 50.1837 8.36433 49.4148 8.36433C48.7196 8.36433 48.119 8.60853 47.6119 9.09693C47.1048 9.58533 46.8518 10.22 46.8518 10.9999C46.8518 11.7798 47.1048 12.4145 47.6119 12.9029C48.119 13.3913 48.7196 13.6355 49.4148 13.6355C50.1518 13.6355 50.7667 13.3902 51.2584 12.8985C51.5774 12.5784 51.7622 12.1329 51.8117 11.562H49.4148V10.7689H52.6125C52.6455 10.9416 52.6598 11.1077 52.6598 11.2672Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7309 8.51069H54.7257V10.6029H57.4361V11.396H54.7257V13.4882H57.7309V14.3H53.8776V7.69999H57.7309V8.51069Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3069 14.3H60.4588V8.51069H58.6152V7.69999H63.1505V8.51069H61.3069V14.3Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4318 14.3V7.69999H67.2799V14.3H66.4318Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.041 14.3H70.1929V8.51069H68.3493V7.69999H72.8846V8.51069H71.041V14.3Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4698 13.4475C80.8208 14.1141 80.0145 14.4474 79.0498 14.4474C78.0851 14.4474 77.2788 14.1141 76.6309 13.4475C75.9819 12.7809 75.6585 11.9647 75.6585 11C75.6585 10.0353 75.9819 9.21908 76.6309 8.55248C77.2788 7.88588 78.0851 7.55148 79.0498 7.55148C80.009 7.55148 80.8142 7.88698 81.4654 8.55688C82.1166 9.22678 82.4422 10.0408 82.4422 11C82.4422 11.9647 82.1177 12.7809 81.4698 13.4475ZM77.2568 12.8942C77.7452 13.3892 78.3425 13.6356 79.0498 13.6356C79.7571 13.6356 80.3555 13.3881 80.8428 12.8942C81.3312 12.3992 81.5765 11.7678 81.5765 11C81.5765 10.2322 81.3312 9.60078 80.8428 9.10578C80.3555 8.61078 79.7571 8.36438 79.0498 8.36438C78.3425 8.36438 77.7452 8.61188 77.2568 9.10578C76.7695 9.60078 76.5242 10.2322 76.5242 11C76.5242 11.7678 76.7695 12.3992 77.2568 12.8942Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6324 14.3V7.69999H84.6642L87.8718 12.8337H87.9081L87.8718 11.5621V7.69999H88.7199V14.3H87.8344L84.4783 8.91659H84.442L84.4783 10.1882V14.3H83.6324Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_108_62382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9796 8.29179C11.6595 8.63059 11.4703 9.15639 11.4703 9.83729V34.1649C11.4703 34.8469 11.6595 35.3716 11.9796 35.7104L12.061 35.7896L25.6889 22.1617V22.0011V21.8405L12.061 8.21149L11.9796 8.29179Z",
    fill: "url(#paint0_linear_108_62382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2308 26.7058L25.6889 22.1617V22.0011V21.8405L30.2319 17.2975L30.3342 17.3558L35.7165 20.4138C37.2532 21.2872 37.2532 22.7161 35.7165 23.5906L30.3342 26.6486L30.2308 26.7058Z",
    fill: "url(#paint1_linear_108_62382)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_108_62382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3342 26.6475L25.6878 22.0011L11.9796 35.7104C12.4856 36.2472 13.3227 36.3132 14.2654 35.7786L30.3342 26.6475Z",
    fill: "url(#paint2_linear_108_62382)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.3342 17.3547L14.2654 8.22469C13.3227 7.68899 12.4856 7.75609 11.9796 8.29289L25.6889 22.0022L30.3342 17.3547Z",
    fill: "url(#paint3_linear_108_62382)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 147.5,
    height: 43,
    rx: 4.5,
    stroke: "#A6A6A6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_108_62382",
    x: 11.4703,
    y: 7.85501,
    width: 25.3987,
    height: 28.2928,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_108_62382"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_108_62382",
    result: "effect2_innerShadow_108_62382"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_108_62382",
    x: 11.9796,
    y: 22.0011,
    width: 18.3546,
    height: 14.1468,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_108_62382"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_108_62382",
    x1: 24.4809,
    y1: 9.57989,
    x2: 6.02069,
    y2: 28.0401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_108_62382",
    x1: 37.7168,
    y1: 22.0011,
    x2: 11.1013,
    y2: 22.0011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_108_62382",
    x1: 27.8109,
    y1: 24.5244,
    x2: 2.77655,
    y2: 49.5587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_108_62382",
    x1: 8.52712,
    y1: 0.194474,
    x2: 19.7057,
    y2: 11.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.6fa233a901207ca0daf58fbf26357131.svg";
export { ForwardRef as ReactComponent };